module.exports = __webpack_public_path__ + "5508bcdd8d07a20f4251743905bc8fe9.svg";